module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/my_page-763e5bd2dd39b23d1c1602640fcff8e0.png";